import { useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { GoldButton, Section } from "@/components/site/Ui";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { ExternalLink, Info } from "lucide-react";

export default function Gear() {
  const [gear, setGear] = useState([]);
  useEffect(() => { api.get("/gear").then((r) => setGear(r.data)).catch(() => {}); }, []);

  return (
    <>
      <div className="relative grain overflow-hidden">
        <Section className="pb-8">
          <Reveal>
            <Eyebrow>Recommended Gear</Eyebrow>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.05]">Simple gear that makes a big difference.</h1>
            <p className="mt-5 text-white/70 max-w-xl text-lg">You don't need much. Here's the affordable kit I recommend for phone creators — with a quick video on each.</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6 flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.02] p-4 max-w-2xl text-xs text-white/50">
              <Info size={16} className="text-[#D4AF37] shrink-0 mt-0.5" />
              <p>Some links on this page are affiliate links. If you buy through them, I may earn a small commission at no extra cost to you. As an Amazon Associate I earn from qualifying purchases.</p>
            </div>
          </Reveal>
        </Section>
      </div>

      <Section className="pt-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {gear.map((g, i) => (
            <Reveal key={g.id} delay={i * 0.06}>
              <div className="card-surface rounded-2xl overflow-hidden h-full flex flex-col gold-glow-hover">
                {g.image && (
                  <div className="aspect-[4/3] overflow-hidden bg-black">
                    <img src={mediaUrl(g.image)} alt={g.name} loading="lazy" className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-[10px] uppercase tracking-widest text-[#D4AF37]">{g.category}</span>
                    <span className="text-sm text-white/50">{g.price_range}</span>
                  </div>
                  <h3 className="mt-2 text-lg font-display">{g.name}</h3>
                  <p className="mt-2 text-sm text-white/60 leading-relaxed flex-1">{g.description}</p>
                  {g.youtube_video_id && (
                    <div className="mt-4 aspect-video rounded-lg overflow-hidden bg-black">
                      <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${g.youtube_video_id}`} title={g.name} allowFullScreen />
                    </div>
                  )}
                  <GoldButton as="a" href={g.affiliate_link} target="_blank" rel="noreferrer nofollow sponsored"
                    data-testid={`gear-amazon-${i}`} variant="outline" className="mt-5 w-full">
                    {g.link_label || "View on Amazon"} <ExternalLink size={15} />
                  </GoldButton>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
    </>
  );
}
